
import { Box, Paper, Select } from '@mui/material';
import { styled } from '@mui/material/styles';
export const Container = styled(Paper)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(2),
  borderRadius: 8,
}));

export const StyledSelect = styled(Select)(({ theme }) => ({
  minWidth: `100%`,
}));

export const StyledPlanBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  border: "1px solid #ccc",
  borderRadius: 4,
  padding: theme.spacing(1, 2),
  width: "100%",
}));